import React, { useEffect } from "react";
import { DotsNine } from "phosphor-react";
import "components/common/header/header.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "hooks/authentication/useAuth";
import {
  Fade,
  IconButton,
  Menu,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { logout } from "services/UserManagementServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faBars } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { changeLanguagePreference } from "services/UserAccountManagementServices";
import NotificationCenter from "../notification";

const Header = (props) => {
  const { toggleNav, togglePanel, showNav } = props;
  const location = useLocation();

  const LanguageDropDown = () => {
    const [anchorEll, setAnchorEll] = React.useState(null);
    const open = Boolean(anchorEll);

    const handleClick = (event) => {
      setAnchorEll(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEll(null);
    };
    const languageChanger = async (event) => {
      let key = event.target.value;
      i18next.changeLanguage(key);
      localStorage.setItem("LanguagePreference", JSON.stringify(key));
      handleClose();
      const auth = JSON.parse(localStorage.getItem("userId"));
      if (auth) {
        changeLanguagePreference(key);
      }
    };
    return (
      <>
        <div>
          <label
            style={{
              textTransform: "uppercase",
              cursor: "pointer",
              fontWeight: "bold",
              marginLeft: "1rem",
            }}
          >
            {i18next.language}
          </label>
          <IconButton
            sx={{
              cursor: "pointer",
            }}
            aria-label="logout menu"
            size="small"
            aria-controls={open ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <img src="/assets/icons/down-arrow.png" alt="open" />
          </IconButton>
        </div>
        <Menu
          PaperProps={{
            elevation: 2,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.09))",
              mt: 2,
              borderRadius: "8px !important",
            },
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEll}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="radio-buttons-group"
            onChange={languageChanger}
            value={i18next.language}
            sx={{
              paddingLeft: "1rem",
            }}
          >
            <FormControlLabel value="de" control={<Radio />} label="Deutsch" />
            <FormControlLabel value="en" control={<Radio />} label="English" />
          </RadioGroup>
        </Menu>
      </>
    );
  };

  return (
    <header>
      <div className="navbar-sub">
        <div className="action">
          <div id="nav-icon" onClick={toggleNav} className={showNav && "open"}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span
            className="title"
            onClick={() => {
              window.location = "https://volksbank-digital.solutions";
            }}
          >
            VDS Internal
          </span>
        </div>
        {/* {localStorage.getItem("userExists") ? ( */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="d-flex align-items-center px-3">
            <p
              className="mb-0 me-3"
              style={{
                fontWeight: "bold",
              }}
            >
              {localStorage.getItem("email")}
            </p>
            <img
              src="/assets/icons/account-circle.png"
              width={25}
              style={{
                cursor: "pointer",
              }}
              alt="account"
            />
            <LogOutDropDown />
            <LanguageDropDown />
          </div>
          <NotificationCenter />

          <DotsNine
            onClick={togglePanel}
            weight="bold"
            size={35}
            className="icon"
            cursor="pointer"
          />
        </div>
        {/* ) : (
          !location.pathname.includes("login") && (
            <div
              className="named-avatar"
              onClick={() => {
                window.location = "/login";
              }}
            >
              VA
            </div>
          )
        )} */}
      </div>
    </header>
  );
};
const LogOutDropDown = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <div>
        <IconButton
          sx={{
            cursor: "pointer",
          }}
          aria-label="logout menu"
          size="small"
          aria-controls={open ? "fade-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <FontAwesomeIcon icon={faChevronDown} />
        </IconButton>
      </div>
      <Menu
        PaperProps={{
          elevation: 2,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.09))",
            mt: 2,
            borderRadius: "10px !important",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {window.location.pathname !== "/unauthorized-user" && (
          <MenuItem onClick={() => navigate("/profile")}>
            {t("manage-your-account")}
          </MenuItem>
        )}

        <MenuItem
          onClick={async () => {
            await logout();
            localStorage.clear();
            window.location = "/login";
            performLogout();
          }}
        >
          {t("log-out")}
        </MenuItem>
      </Menu>
    </>
  );
};
export default Header;
